import { FC } from "react";
import { IconButton, Stack } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { BillingExplorerFolderListItemActionsMenu } from "./BillingExplorerFolderListItemActionsMenu";
import { navItemSecondaryActionButtonVisibilityStyles } from "../../../../../utils/helpers/navItemSecondaryActionButtonVisibilityStyles";
import { useMenuHook } from "@/utils/hooks/useMenu.hook";
import { NavigationItemsVisibilityType } from "@/store/navigation/utils/types";

interface BillingExplorerViewFolderActionButtonProps {
  id: string;
  name: string;
  size?: "small" | "medium" | "large";
  visibility: NavigationItemsVisibilityType;
  redirectAfterCreate?: boolean;
  containsProtectedItem?: boolean;
}

export const BillingExplorerViewFolderActionButton: FC<
  BillingExplorerViewFolderActionButtonProps
> = ({
  id,
  name,
  visibility,
  size,
  redirectAfterCreate,
  containsProtectedItem,
}) => {
  const { anchor, open, openMenu, closeMenu } = useMenuHook();

  return (
    <Stack direction="row" spacing={0.5} justifyContent="flex-end">
      <IconButton
        size="small"
        onClick={openMenu}
        sx={navItemSecondaryActionButtonVisibilityStyles(open)}
      >
        <MoreVertIcon fontSize={size ?? "inherit"} />
      </IconButton>

      <BillingExplorerFolderListItemActionsMenu
        id={id}
        name={name}
        open={open}
        anchor={anchor}
        closeMenu={closeMenu}
        visibility={visibility}
        redirectAfterCreate={redirectAfterCreate}
        containsProtectedItem={containsProtectedItem}
      />
    </Stack>
  );
};
